'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./avatar.css');

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeckoAvatar = function (_Component) {
    _inherits(GeckoAvatar, _Component);

    function GeckoAvatar() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, GeckoAvatar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GeckoAvatar.__proto__ || Object.getPrototypeOf(GeckoAvatar)).call.apply(_ref, [this].concat(args))), _this), _this.colorClasses = ['gecko-ui-avatar-one', 'gecko-ui-avatar-two', 'gecko-ui-avatar-three', 'gecko-ui-avatar-four', 'gecko-ui-avatar-five', 'gecko-ui-avatar-six'], _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(GeckoAvatar, [{
        key: 'getSizeClass',
        value: function getSizeClass() {
            if (this.props.size) return 'avatar-' + this.props.size;
            return 'avatar-lg';
        }
    }, {
        key: 'getColorClass',
        value: function getColorClass() {
            var FNV1_32A_INIT = 0x811c9dc5;
            var hval = FNV1_32A_INIT;
            for (var i = 0; i < this.props.name.length; ++i) {
                hval ^= this.props.name.charCodeAt(i);
                hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
            }
            return this.colorClasses[(hval >>> 0) % this.colorClasses.length];
        }
    }, {
        key: 'getInitialClass',
        value: function getInitialClass() {
            if (!this.bgImage) return 'avatar-initials';
            return '';
        }
    }, {
        key: 'renderClass',
        value: function renderClass() {
            var baseClasses = 'position-relative avatar gecko-ui-avatar';
            return _.GECKO_UTILS.classNames(baseClasses, this.getInitialClass(), this.getSizeClass());
        }
    }, {
        key: 'renderInitials',
        value: function renderInitials() {
            if (this.props.bgImage) {
                return '\xA0';
            } // don't render initials if there is an image instead render an nbsp; as this keeps positionoing correct
            var value = '';

            // if (this.props.first_name || this.props.last_name) {
            //     value += this.props.first_name ? this.props.first_name[0] : '';
            //     value += this.props.last_name ? this.props.last_name[0] : '';
            //     return value;
            // }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.props.name.split(" ")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var val = _step.value;

                    if (val && val[0]) value += val[0];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return value.slice(0, 2);
        }
    }, {
        key: 'renderStyles',
        value: function renderStyles() {
            var styles = {};
            if (this.props.color) styles['backgroundColor'] = this.props.color;
            //if(this.props.bgImage) styles['backgroundImage'] = `url('${this.props.bgImage}')`;
            if (!this.props.bgImage) styles['color'] = this.getContrastColor(this.props.color);
            return styles;
        }
    }, {
        key: 'getContrastColor',
        value: function getContrastColor(hexcolor) {
            if (!hexcolor) return 'white';
            hexcolor = hexcolor.indexOf('#') > -1 ? hexcolor.replace('#', '') : hexcolor;
            var r = parseInt(hexcolor.substr(0, 2), 16);
            var g = parseInt(hexcolor.substr(2, 2), 16);
            var b = parseInt(hexcolor.substr(4, 2), 16);
            var yiq = (r * 299 + g * 587 + b * 114) / 1000;
            return yiq >= 128 ? '#1a252f' : 'white';
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.bgImage) {
                return _react2.default.createElement(
                    'div',
                    { className: this.renderClass() },
                    _react2.default.createElement('img', {
                        title: this.props.name,
                        alt: this.props.name,
                        className: 'rounded-circle img-fluid',
                        src: this.props.bgImage })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: this.renderClass() },
                _react2.default.createElement(
                    'span',
                    {
                        title: this.props.name,
                        className: 'text-style-uppercase font-size-smaller font-weight-bold rounded-circle ' + this.getColorClass(),
                        style: this.renderStyles() },
                    this.renderInitials()
                )
            );
        }
    }]);

    return GeckoAvatar;
}(_react.Component);

GeckoAvatar.defaultProps = {
    name: ''
};

GeckoAvatar.propTypes = _.GeckoAvatarModel;

exports.default = GeckoAvatar;